<template>
  <div :class="['status-bar', { active: isActive }]">
    <div class="active-bar"></div>
  </div>
</template>

<script>
  let statusBar = {
    name: 'StatusBar',
    props: {
      isActive: {
        type: Boolean,
        default: false
      }
    }
  };
  export default statusBar;
</script>

<style lang="scss" scope>
  $activeColor: var(--default-color);
  $inactiveColor: #00000000;
  $activeBarWidth: 30%;
  .status-bar {
    height: 2px;
    background-color: $inactiveColor;
    overflow: hidden;
    margin-left: 2px;
    margin-right: 4px;

    .active-bar {
      display: none;
    }

    &.active {
      background-color: $inactiveColor;

      .active-bar {
        display: flex;
        width: $activeBarWidth;
        height: 100%;
        background-color: $activeColor;
        position: relative;
        animation: scroll 2s ease-in-out 0s infinite alternate;
      }
    }
  }

  @keyframes scroll {
    from { left: -$activeBarWidth; }
    to { left: 100%; }
  }
</style>